import React from "react";
import "./styles/ownProductShow.css";
import Button from "react-bulma-components/lib/components/button";
import { Redirect } from "react-router-dom";
import moment from "moment";
import { toast } from 'react-toastify';
import Modal from "react-bulma-components/lib/components/modal";
import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from "react-share";
import { inject, observer } from "mobx-react";
import ShareMenu from '../../helpers/shareTheUrl'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import PinchToZoom from "react-pinch-and-zoom";

// var artworks_url_list1 = [
//     { Imgurl: require('../../assets/artwork_picture.png'), artistUrl: require('../../assets/artist_profilepic.png'), artworkData: "Everyday", artworkTechnique: "Watercolor", artworkLikes: "200" },

//     { Imgurl: require('../../assets/painting1.png'), artistUrl: require('../../assets/artist_profilepic.png'), artworkData: "Everyday", artworkTechnique: "Watercolor", artworkLikes: "300" },
//     { Imgurl: require('../../assets/painting2.png'), artistUrl: require('../../assets/artist_profilepic.png'), artworkData: "Everyday", artworkTechnique: "Watercolor", artworkLikes: "400" },
//     { Imgurl: require('../../assets/painting3.png'), artistUrl: require('../../assets/artist_profilepic.png'), artworkData: "Everyday", artworkTechnique: "Watercolor", artworkLikes: "100" },
// ]
@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'likeAndUnlikeStore', 'requestsStore')
@observer
export default class ownProductShow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            // localLiked: false,
            actualLiked: false,
            placedRequestDone: false,
            wantsToBuy: false,
            artworkClicked: false,
            wantsToViewProfile: false,
            artistClicked: false,
            fullScreenImage: false,
            currentImageToPreview: false,
            wantsToEdit: false,
            reportBody: {
                report_type: 0,
                // customReportReason : ""
            }
        }

    }
    static contextTypes = {
        router: () => true, // replace with PropTypes.object if you use them
    }
    handleLikeClick(id) {
        this.setState({
            actualLiked: !this.state.actualLiked,
            likes_received: this.state.likes_received + (this.state.actualLiked ? +1 : -1),
            likeInProcess: true,
        }, () => {
            var str = this.props.details.artwork.id;
            (localStorage.hasOwnProperty("userData")) ?

                (this.state.actualLiked) ?

                    this.props.likeAndUnlikeStore.likeTheArtwork(str)
                        .then((res) => {
                            // console.log(res)
                            toast("This artwork was added to your collection!")
                            this.props.artworksStore.getArtworkDetailsPublicAuth(str, null, true)
                                .then((resp) => {
                                    // console.log("this is artwork data", resp);
                                    this.setState({
                                        likeInProcess: false,
                                        // artworkData: resp.data[0],
                                        // currentImageToPreview: resp.data[0].img1,
                                        // actualLiked: resp.data.data[0].artwork.liked,
                                        // likes_received: resp.data.data[0].artwork.total_likes_received
                                    }, function () {
                                        // console.log(resp, this.state.artworkData)
                                    })
                                })
                                .catch((err) => {
                                    // console.log("Something went wrong. Please try again.");
                                    return
                                })
                        })
                    :
                    this.props.likeAndUnlikeStore.unLikeTheArtwork(str)
                        .then((res) => {
                            // console.log(res)
                            this.props.artworksStore.getArtworkDetailsPublicAuth(str, null, true)
                                .then((resp) => {
                                    toast("This artwork was removed from your collection!")
                                    // console.log("this is artwork data", resp);
                                    this.setState({
                                        likeInProcess: false,
                                        // artworkData: resp.data[0],
                                        // currentImageToPreview: resp.data[0].img1,
                                        // actualLiked: resp.data.data[0].artwork.liked,
                                        // total_likes_received: resp.data.data[0].artwork.total_likes_received
                                    }, function () {
                                        // console.log(resp, this.state.artworkData)
                                    })
                                })
                                .catch((err) => {
                                    // console.log("Something went wrong. Please try again.");
                                    return
                                })
                        })
                : this.props.navigatorStore.openSignInModal()
        })

    }
    handleArtworkClick() {
        this.setState({
            artworkClicked: !this.state.artworkClicked
        })
    }
    handleArtistClick() {
        this.setState({
            artistClicked: !this.state.artistClicked
        })
    }
    handleBuyRequestBtn() {

        if (this.state.myOwnArtwork) {
            this.setState({
                wantsToEdit: true
            })
        }

        else
            // this.props.requestsStore.artworkBuyRequest(this.state.artworkId)
            //     .then((res) => {
            //         // console.log(res)
            if (localStorage.hasOwnProperty("userData")) {
                this.setState({
                    wantsToBuy: true,
                })
            }

            else {
                // this.closeArtworkModal()
                this.props.navigatorStore.openSignInModal()
            }
        // })




    }
    handleImageCarouselClick(item) {
        this.setState({
            currentImageToPreview: item
        })
    }

    handleViewProfileClick(id) {

        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            return;
        }
        this.setState({
            wantsToViewProfile: true,
            clickedArtistId: id
        })


    }
    fullScreenImage() {
        this.setState({
            fullScreenImage: true
        })
    }
    onCloseFullScreenImage() {
        this.setState({
            fullScreenImage: false
        })
    }

    componentWillReceiveProps(nextProps) {
        // console.log('[mounted] srchpage ', nextProps.details)
        var searchableString = nextProps.details.artwork.id;

        // console.log({ matcher: searchableString != this.state.artworkId, })
        if (searchableString != this.state.artworkId) {

            // this.props.artworksStore.getArtworkDetailsPublicAuth(nextProps.id)
            //     .then((resp) => {
            //         // console.log("this is artwork data", resp);
            this.setState({
                artworkId: nextProps.details.artwork.id,
                artworkData: nextProps.details,
                currentImageToPreview: nextProps.details.artwork.img1,
                actualLiked: nextProps.details.liked,
                buyRequestDone: nextProps.details.br_sent,
                total_likes_received: nextProps.details.artwork.total_likes_received,
                myOwnArtwork: (nextProps.details.artwork.user_profile.id == (localStorage.getItem("profile_id")))
            }, function () {
                // // console.log(resp, this.state.buyRequestDone)
            })
            // })
            // .catch((err) => {
            //     this.props.navigatorStore.openErrorModal(err);
            //     return
            // })




            // document.addEventListener('scroll', this.trackScrolling);
        }
    }
    componentDidMount() {
        var str = this.props.id;

        // debugger;
        // window.localStorage.hasOwnProperty("userData") ?
        //     this.props.artworksStore.getArtworkDetailsPublicAuth(str)
        //         .then((resp) => {
        //             // console.log("this is artwork data", resp);
        var ds = this.props.details.artwork.created_at
        var date = moment(new Date(ds.substr(0, 16)));
        var dateF = date.format("DD MMMM YYYY")
        // console.log("mounted profile inhere", this.props)
        this.setState({
            artworkId: this.props.details.artwork.id,
            artworkData: this.props.details,
            currentImageToPreview: this.props.details.artwork.img1,
            actualLiked: this.props.details.liked,
            buyRequestDone: this.props.details.br_sent,
            total_likes_received: this.props.details.artwork.total_likes_received,
            uploaded_on: dateF,
            myOwnArtwork: (this.props.details.artwork.user_profile.id == (localStorage.getItem("profile_id"))),
            likes_received: this.props.details.artwork.total_likes_received
        }, function () {
            // console.log("mounted profile inhere", this.state)
        })
        //     // })
        //     // .catch((err) => {
        //     //     this.props.navigatorStore.openErrorModal(err);
        //     //     return
        //     // })
        // :

        // this.props.artworksStore.getArtworkDetailsPublic(str)
        //     .then((resp) => {
        //         // console.log("this is artwork data", resp);
        //         this.setState({
        //             artworkData: resp.data[0],
        //             currentImageToPreview: resp.data[0].img1,

        //         }, function () {
        //             // console.log(resp, this.state.artworkData)
        //         })
        //     })
        //     .catch((err) => {
        //         this.props.navigatorStore.openErrorModal(err);
        //         return
        //     })


        // this.props.landingPageArtworksStore.getInitialArtworksByCategory({ search: "living_room" })
        //     .then((res) => {
        //         // console.log("[look at response]", res)
        //         this.setState({

        //             featuredArtworksList: res.data.data
        //         }, function () {
        //             // console.log("[look at artworks state]", this.state.artworksList);
        //             // console.log(this.state.response)
        //         })
        //     })
    }

    componentWillMount() {

    }

    handleReportModal() {
        if (!localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            return;
        }
        this.setState({

            reportModalOpen: true
        }
        )
    }
    closeReportModal() {
        this.setState({

            reportModalOpen: false
        })
    }

    handleReportArtwork() {

        this.props.artworksStore.reportArtwork(this.state.artworkId, this.state.reportBody)
            .then((res) => {
                this.setState({
                    reportedThisArtwork: true
                }, () => this.props.navigatorStore.closeArtworkDetailsModal()
                )
            })


    }

    handleReasonSelect(reportType) {
        this.setState({
            reportBody: {
                ...this.state.reportBody,
                report_type: reportType
            }
        }, function () {
            // console.log(this.state.reportBody)
        })
    }

    handleShareButton() {
        if (!window.localStorage.hasOwnProperty("userData")) {
            this.props.navigatorStore.openSignInModal();
            this.props.navigatorStore.closeArtworkDetailsModal()
        }
    }


    closeArtworkModal() {
        this.props.navigatorStore.closeArtworkDetailsModal()
    }
    render() {
        if (this.state.reportedThisArtwork) {
            return (
                <Redirect push to="/artwork-not-available">

                </Redirect>
            )
        }
        const ReportReasons = [
            {
                value: 1, display: "It is my artwork"
            },
            {
                value: 2, display: "Inappropriate/disturbing content"
            },
            {
                value: 3, display: "Mature content"
            },
            {
                value: 4, display: "Not original"
            },
            // {
            //     value: 5, display: "Others"
            // },
        ]


        const imagesPath = {
            unchecked: require('../../assets/unchecked.png'),
            checked: require('../../assets/checked.png')
        }
        const imageList = [
            { url: (this.state.artworkData) ? this.state.artworkData.artwork.img1 : "" },
            { url: (this.state.artworkData) ? this.state.artworkData.artwork.img2 : "" },
            { url: (this.state.artworkData) ? this.state.artworkData.artwork.img3 : "" }
        ]
        // console.log("[imageList]", imageList)

        if (this.state.artworkClicked) {
            return (
                <Redirect push to="/product/details/">

                </Redirect>
            )
        }

        if (this.state.wantsToEdit) {
            return (
                <Redirect push to={{ pathname: `/uploadimage2/:${this.state.artworkData.id}` }}>

                </Redirect>
            )
        }
        if (this.state.artistClicked) {
            return (
                <Redirect push to="/profile/details/">

                </Redirect>
            )
        }

        if (this.state.wantsToBuy) {
            return (
                <Redirect push to={`/place-buy-request/${this.state.artworkId}`} />
            )
        }
        if (this.state.wantsToViewProfile) {
            return (
                <Redirect push to={{
                    pathname: `/profile/details/${this.state.clickedArtistId}`,
                    state: { id: this.state.clickedArtistId }
                }} />
            )
        };


        var res = ""
        return (
            (this.state.artworkData) ?
                <Modal style={{ zIndex: "80" }} show={this.props.navigatorStore.openArtworkDetails} onClose={this.closeArtworkModal.bind(this)}>
                    <Modal.Content style={{ height: "auto", width: "90%", zIndex: "80" }}>
                        <img onClick={this.closeArtworkModal.bind(this)} className="cross-icon-for-fullscreen-image-modal" src={require('../../assets/cross_icon_for_close.png')}></img>
                        <div className="product-details-page-container">
                            <div className="product-details-container">
                                <div className="breadcrumbs-details">
                                    {/* <Button onClick={this.context.router.history.goBack}>>Return</Button> */}
                                    {/* Artwork / Watercolor / Artwork name */}
                                </div>
                                <div className="product-details">
                                    <div className="product-details-product-images">
                                        <div className="product-details-image-preview-window">
                                            <div className="product-details-big-preview" onClick={this.fullScreenImage.bind(this)}>
                                                {/* <ReactImageZoom {..._props} /> */}
                                                <img style={{
                                                    maxHeight: "70vh",
                                                    maxWidth: "auto"
                                                }} src={this.state.currentImageToPreview} />
                                            </div>


                                            <Modal className="full-preview-image" show={this.state.fullScreenImage} onClose={this.onCloseFullScreenImage.bind(this)} >
                                                <img onClick={this.onCloseFullScreenImage.bind(this)} className="cross-icon-for-fullscreen-image-modal" src={require('../../assets/cross_icon_for_close.png')}></img>
                                                <Modal.Content style={{ width: "auto" }}>
                                                    <PinchToZoom>
                                                        <img className="fullscreen-image" src={this.state.currentImageToPreview} />
                                                    </PinchToZoom>
                                                </Modal.Content>
                                            </Modal>
                                            <div style={{ display: "flex" }}>
                                                <div style={{ flex: 1 }} className="product-details-list-preview">
                                                    <ImagePreviewWindow imageList={imageList} handleImageCarouselClick={this.handleImageCarouselClick.bind(this)} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className="d-flex justify-content-end created-by-text">
                                            Created by
                                            <span>{(this.state.artworkData.artwork.created_by) ? (this.state.artworkData.artwork.created_by.length) ? this.state.artworkData.artwork.created_by : this.state.artworkData.user_profile.display_name || this.state.artworkData.user_profile.old_display_name : ""}
                                            </span>
                                        </div> */}

                                    </div>


                                    <div className="product-details-product-data">
                                        <div className="product-details-product-name">
                                            {(this.state.artworkData.artwork.title) ? this.state.artworkData.artwork.title : this.state.artworkData.artwork.old_title}
                                        </div>
                                        {
                                            (localStorage.hasOwnProperty("preferred_currency") && !!this.state.artworkData.artwork.seller_price) ?
                                                <div className="product-details-product-cost">
                                                    <p className="price-text" style={{ display: (this.state.artworkData.artwork.wish_to_sell) ? "" : "none" }}>{localStorage.getItem("preferred_currency").toUpperCase()}{` `}{this.state.artworkData.artwork.product_converted_price}*</p>
                                                    <p className="cost-terms-and-conds" style={{ display: (this.state.artworkData.artwork.wish_to_sell) ? "none" : "none" }}>
                                                        * shipping and handling charges extra
                                                    </p>
                                                    <p style={{
                                                        display: (this.state.artworkData.artwork.wish_to_sell) ? "none" : "",
                                                        fontSize: "25px", coolor: "#666666", fontWeight: "300"
                                                    }}> Not For Sale </p>
                                                </div>
                                                :
                                                (this.state.artworkData.artwork.seller_price) ?
                                                    <div className="product-details-product-cost">
                                                        <p className="price-text" style={{ display: (this.state.artworkData.artwork.wish_to_sell) ? "" : "none" }}>{this.state.artworkData.artwork.currency_code.toUpperCase()}{` `}{`${this.state.artworkData.artwork.product_base_price}`}*</p><p className="cost-terms-and-conds" style={{ display: (this.state.artworkData.artwork.wish_to_sell) ? "none" : "none" }}>
                                                            * shipping and handling charges extra
                                                        </p>
                                                        <p style={{
                                                            display: (this.state.artworkData.artwork.wish_to_sell) ? "none" : "",
                                                            fontSize: "25px", coolor: "#666666", fontWeight: "300"
                                                        }}> Not For Sale </p>
                                                    </div>
                                                    :
                                                    <div className="product-details-product-cost">
                                                        <p className="price-text" style={{ display: (this.state.artworkData.artwork.wish_to_sell) ? "" : "none" }}>{`${this.state.artworkData.artwork.old_seller_price} `}*</p><p className="cost-terms-and-conds" style={{ display: (this.state.artworkData.artwork.wish_to_sell) ? "none" : "none" }}>
                                                            * shipping and handling charges extra
                                                        </p>
                                                        <p style={{
                                                            display: (this.state.artworkData.artwork.wish_to_sell) ? "none" : "",
                                                            fontSize: "25px", coolor: "#666666", fontWeight: "300"
                                                        }}> Not For Sale </p>
                                                    </div>


                                        }
                                        <div className="artwork-buy-request-and-likes">
                                            <div className="artwork-buy-request-btn">
                                                <BuyRequestButton myOwnArtwork={this.state.myOwnArtwork} handleBuyRequestBtn={this.handleBuyRequestBtn.bind(this)} buyRequestDone={this.state.buyRequestDone} />
                                                {/* <EditArtworkButton /> */}
                                            </div>
                                            <div className="artwork-likes-and-like-btn" style={{ marginLeft: "5px" }}>
                                                <div className="artworks-likes" onClick={(this.state.likeInProcess) ? "" : this.handleLikeClick.bind(this)} style={{ cursor: "pointer" }}>
                                                    <img className="artwork-likes-icon"  src={(this.state.actualLiked) ? require('../../assets/heart copy 2_svg (2).svg') : require('../../assets/heart copy 2_svg.svg')} />
                                                    <p className="like-number">{this.state.likes_received} </p>
                                                </div>
                                                <div className="artwork-like-btn " style={{ flex: "unset" }}>
                                                    <UncontrolledDropdown nav inNavbar>
                                                        <DropdownToggle nav caret>
                                                            <Button className="masterpieces-secondary-buttons share-button"
                                                                onClick={() => this.handleShareButton(this.state.artworkData.share_url)}
                                                            >SHARE</Button>
                                                        </DropdownToggle>
                                                       <ShareMenu share_url={this.state.artworkData.artwork.share_url}/>
                                                    </UncontrolledDropdown>
                                                </div>
                                                <UncontrolledDropdown nav inNavbar reportArtworkBlock>
                                                    <DropdownToggle nav caret>
                                                        <Button className="masterpieces-secondary-buttons report-btn"><img className="dropdown-arrow" src={require('../../assets/down_arrow.png')}></img></Button>
                                                    </DropdownToggle>
                                                    <DropdownMenu className="notificationDropdown">
                                                        <DropdownItem onClick={this.handleReportModal.bind(this)}>
                                                            REPORT ARTWORK
                                                </DropdownItem>

                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </div>
                                        </div>
                                        <Modal show={this.state.reportModalOpen} onClose={this.closeReportModal.bind(this)} >

                                            <Modal.Content >
                                                <div className="masterpieces-modal-header pt-20 pb-25 pl-25">
                                                    <p className="masterpieces-modal-heading">Report artwork
                                                <img onClick={this.closeReportModal.bind(this)}
                                                            className="cross-icon-for-masterpieces-modal"
                                                            src={require('../../assets/cross_icon_for_close.png')}></img>
                                                    </p>

                                                </div>
                                                <div className="report-artwork-content pt5 pl-25">

                                                    <p className="please-choose-a-reas mb-15">Please choose a reason for
                                                        reporting the
                                                artwork</p>

                                                    <div className="filter-price-checkboxes mt-15">
                                                        {
                                                            ReportReasons.map((el, idx) => (
                                                                < div className="filters-list-container report-block">
                                                                    <img onClick={() => this.handleReasonSelect(el.value)} alt="" className="filters-checkbox"
                                                                        src={
                                                                            (this.state.reportBody.report_type == el.value) ?
                                                                                imagesPath.checked : imagesPath.unchecked} />
                                                                    <p className="report-label-name">{el.display}</p>
                                                                </div>
                                                            )
                                                            )
                                                        }
                                                        {/* <div className="filters-list-container report-block">
                                                <img alt="" className="filters-checkbox"
                                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAADS0lEQVR4nO2bzWoUQRSF69Z04ojmAVRIFi6E4BOIqEEUJEoEIWiyVBDEn4ULF8YQYly4yEIjLvzbJUpAcNRREDQq4hNIRIgggvoASciE9PS1Ts9PanpwQE3XTSb1LcL07Wo451Z1VS9ySDXg4+TItkK42GN+ditW20nxVlaqrdEz0pBSs6zoJ5GaIaZ8a0vr0129Az8ajK/n/eNrW8JCYUgRnzTGM+nJTR8iCpnVgyCbHdpz7PKvuvvJwtuJwSPM0fhqn+m/BSvDTGVf1/GR53Zd2xdT41fORsxPms08gCcuUg4e7Xp1BUw9GjiMAWaorn2UprXmewHTK7Vp8/fdPZdm3Uj+Nz7krrep+bn2kPhgFNEp46ezdgRFmujovr7hZ/EV/uCdLxYWvtgzb24sEemLe4Odt6m3t+jSxErBk5OZd+GnM+aVHjXeWip1vA6Z7MYd2BMCFOINL2GetT7UdWL4tXvZK0d54samxoc+kwpfVJqAiS57Pk046hbDxW/MHFQe1KTPmyUyJqQ7Fczmfi7i6Ga1QKqYDbIdGue8bR7vPJa9gMZUKXmi6WrBHO/wjg2v2x6IDW+tvvONgCd4S5S7Nb7w7Eq82zcpdd6Md43P25qiOepcinJKwhu86+RHz2o/5/+HpDd4138avF7wDZAWII1vgLQAaXwDpAVI4xsgLUAa3wBpAdL4BkgLkMY3QFqANL4B0gKk8Q2QFiCNb4C0AGl8A6QFSOMbIC1AGt8AaQHS+AZIC5DGN0BagDS+AdICpPENkBYgjW+AtABpfAOkBUij4ySFRfz/9k1K0hu8awSMakbNz7U7VeWQpYWFDvsa3rVpw1e7iKSFW1nuIA4P1FyTmsEekLeLiJkgaeFUmQPgqRShWQaxOp0NNuQQHrCGdiJm4lpg2pQ8LeeHEKdDplDHoUKm+/ZgZGzePBzc715mOsALPNk1ZAnhPT4GESq0TwNkayiKXiJmspZfB2iHB3hJhqbgufy7BAKTyAyuh9gcZbinEqCsSY4iVGg6daO+Cc2CMa/Uha7+q7eqleQQBCjNljjRbOlRLHsi3V8JTFaom2ksDYQKzSN3sFO6k5gSOOFI3YWnpPnS7Qas5fh8+QMvj2O+UXz+N+UpS1yioTXtAAAAAElFTkSuQmCC" />
                                                <p className="report-label-name">Inappropriate/disturbing
                                                        content</p>
                                            </div>
                                            <div className="filters-list-container report-block">
                                                <img alt="" className="filters-checkbox"
                                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAADS0lEQVR4nO2bzWoUQRSF69Z04ojmAVRIFi6E4BOIqEEUJEoEIWiyVBDEn4ULF8YQYly4yEIjLvzbJUpAcNRREDQq4hNIRIgggvoASciE9PS1Ts9PanpwQE3XTSb1LcL07Wo451Z1VS9ySDXg4+TItkK42GN+ditW20nxVlaqrdEz0pBSs6zoJ5GaIaZ8a0vr0129Az8ajK/n/eNrW8JCYUgRnzTGM+nJTR8iCpnVgyCbHdpz7PKvuvvJwtuJwSPM0fhqn+m/BSvDTGVf1/GR53Zd2xdT41fORsxPms08gCcuUg4e7Xp1BUw9GjiMAWaorn2UprXmewHTK7Vp8/fdPZdm3Uj+Nz7krrep+bn2kPhgFNEp46ezdgRFmujovr7hZ/EV/uCdLxYWvtgzb24sEemLe4Odt6m3t+jSxErBk5OZd+GnM+aVHjXeWip1vA6Z7MYd2BMCFOINL2GetT7UdWL4tXvZK0d54samxoc+kwpfVJqAiS57Pk046hbDxW/MHFQe1KTPmyUyJqQ7Fczmfi7i6Ga1QKqYDbIdGue8bR7vPJa9gMZUKXmi6WrBHO/wjg2v2x6IDW+tvvONgCd4S5S7Nb7w7Eq82zcpdd6Md43P25qiOepcinJKwhu86+RHz2o/5/+HpDd4138avF7wDZAWII1vgLQAaXwDpAVI4xsgLUAa3wBpAdL4BkgLkMY3QFqANL4B0gKk8Q2QFiCNb4C0AGl8A6QFSOMbIC1AGt8AaQHS+AZIC5DGN0BagDS+AdICpPENkBYgjW+AtABpfAOkBUij4ySFRfz/9k1K0hu8awSMakbNz7U7VeWQpYWFDvsa3rVpw1e7iKSFW1nuIA4P1FyTmsEekLeLiJkgaeFUmQPgqRShWQaxOp0NNuQQHrCGdiJm4lpg2pQ8LeeHEKdDplDHoUKm+/ZgZGzePBzc715mOsALPNk1ZAnhPT4GESq0TwNkayiKXiJmspZfB2iHB3hJhqbgufy7BAKTyAyuh9gcZbinEqCsSY4iVGg6daO+Cc2CMa/Uha7+q7eqleQQBCjNljjRbOlRLHsi3V8JTFaom2ksDYQKzSN3sFO6k5gSOOFI3YWnpPnS7Qas5fh8+QMvj2O+UXz+N+UpS1yioTXtAAAAAElFTkSuQmCC" />
                                                <p className="report-label-name">Mature content</p>
                                            </div>
                                            <div className="filters-list-container report-block">
                                                <img alt="" className="filters-checkbox"
                                                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAADS0lEQVR4nO2bzWoUQRSF69Z04ojmAVRIFi6E4BOIqEEUJEoEIWiyVBDEn4ULF8YQYly4yEIjLvzbJUpAcNRREDQq4hNIRIgggvoASciE9PS1Ts9PanpwQE3XTSb1LcL07Wo451Z1VS9ySDXg4+TItkK42GN+ditW20nxVlaqrdEz0pBSs6zoJ5GaIaZ8a0vr0129Az8ajK/n/eNrW8JCYUgRnzTGM+nJTR8iCpnVgyCbHdpz7PKvuvvJwtuJwSPM0fhqn+m/BSvDTGVf1/GR53Zd2xdT41fORsxPms08gCcuUg4e7Xp1BUw9GjiMAWaorn2UprXmewHTK7Vp8/fdPZdm3Uj+Nz7krrep+bn2kPhgFNEp46ezdgRFmujovr7hZ/EV/uCdLxYWvtgzb24sEemLe4Odt6m3t+jSxErBk5OZd+GnM+aVHjXeWip1vA6Z7MYd2BMCFOINL2GetT7UdWL4tXvZK0d54samxoc+kwpfVJqAiS57Pk046hbDxW/MHFQe1KTPmyUyJqQ7Fczmfi7i6Ga1QKqYDbIdGue8bR7vPJa9gMZUKXmi6WrBHO/wjg2v2x6IDW+tvvONgCd4S5S7Nb7w7Eq82zcpdd6Md43P25qiOepcinJKwhu86+RHz2o/5/+HpDd4138avF7wDZAWII1vgLQAaXwDpAVI4xsgLUAa3wBpAdL4BkgLkMY3QFqANL4B0gKk8Q2QFiCNb4C0AGl8A6QFSOMbIC1AGt8AaQHS+AZIC5DGN0BagDS+AdICpPENkBYgjW+AtABpfAOkBUij4ySFRfz/9k1K0hu8awSMakbNz7U7VeWQpYWFDvsa3rVpw1e7iKSFW1nuIA4P1FyTmsEekLeLiJkgaeFUmQPgqRShWQaxOp0NNuQQHrCGdiJm4lpg2pQ8LeeHEKdDplDHoUKm+/ZgZGzePBzc715mOsALPNk1ZAnhPT4GESq0TwNkayiKXiJmspZfB2iHB3hJhqbgufy7BAKTyAyuh9gcZbinEqCsSY4iVGg6daO+Cc2CMa/Uha7+q7eqleQQBCjNljjRbOlRLHsi3V8JTFaom2ksDYQKzSN3sFO6k5gSOOFI3YWnpPnS7Qas5fh8+QMvj2O+UXz+N+UpS1yioTXtAAAAAElFTkSuQmCC" />
                                                <p className="report-label-name">Not original</p>
                                            </div>
                                            */}
                                                        <div className="form-group mt-25">
                                                            <label htmlFor="from-price">Others</label>
                                                            <textarea name="report-bio"
                                                                className="form-element-large-input-profile-details bge6 mb-15">
                                                            </textarea>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="report-footer">
                                                    <button onClick={this.handleReportArtwork.bind(this)} className="masterpieces-primary-buttons btn-primary report-button pull-right">Report
                                            </button>
                                                </div>

                                            </Modal.Content>
                                        </Modal>
                                        <div className="product-details-artwork-data">
                                            {
                                                (this.state.artworkData.artwork.base) ?
                                                    <div>
                                                        {/* <hr className="artwork-details-horizontal-rule"></hr> */}
                                                        <div className="product-details-artwork-dimensions-year-technique">
                                                            <p className="product-details-artwork-title">MEDIUM</p>
                                                            <p className="product-details-artwork-value">{(this.state.artworkData.artwork.medium.includes(",")) ?
                                                                this.state.artworkData.artwork.medium.substring(0, this.state.artworkData.artwork.medium.lastIndexOf(",")) :
                                                                this.state.artworkData.artwork.medium}</p>
                                                        </div>
                                                        <hr className="artwork-details-horizontal-rule"></hr>
                                                        <div className="product-details-artwork-dimensions-year-technique">
                                                            <p className="product-details-artwork-title">BASE</p>
                                                            <p className="product-details-artwork-value">{(this.state.artworkData.artwork.base.includes(",")) ?
                                                                this.state.artworkData.artwork.base.substring(0, this.state.artworkData.artwork.base.lastIndexOf(",")) :
                                                                (this.state.artworkData.artwork.base)}</p>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div>
                                                        {/* <hr className="artwork-details-horizontal-rule"></hr> */}
                                                        <div className="product-details-artwork-dimensions-year-technique">
                                                            <p className="product-details-artwork-title">TECHNIQUE</p>
                                                            <p className="product-details-artwork-value">{this.state.artworkData.artwork.medium}</p>
                                                        </div>
                                                    </div>
                                            }
                                            <hr className="artwork-details-horizontal-rule"></hr>
                                            {
                                                localStorage.hasOwnProperty("preferred_dimension") ?
                                                    <div className="product-details-artwork-dimensions-year-technique">
                                                        <p className="product-details-artwork-title">DIMENSIONS</p>
                                                        <p className="product-details-artwork-value">{this.state.artworkData.artwork.base_width || 0}{` x `}{this.state.artworkData.artwork.base_height || 0}{` x `}{this.state.artworkData.artwork.base_depth || 0}{` `}{localStorage.getItem("preferred_dimension")}</p>
                                                    </div>
                                                    :
                                                    (this.state.artworkData.artwork.dimension) ?
                                                        <div className="product-details-artwork-dimensions-year-technique">
                                                            <p className="product-details-artwork-title">DIMENSIONS</p>
                                                            <p className="product-details-artwork-value">{this.state.artworkData.artwork.width || 0}{` x `}{this.state.artworkData.artwork.height || 0}{` x `}{this.state.artworkData.artwork.depth || 0}{` `}{this.state.artworkData.artwork.dimension.toLowerCase()}</p>
                                                        </div>
                                                        :
                                                        <div className="product-details-artwork-dimensions-year-technique">
                                                            <p className="product-details-artwork-title">DIMENSIONS</p>
                                                            <p className="product-details-artwork-value">{this.state.artworkData.artwork.old_dimension}</p>
                                                        </div>
                                            }
                                            <hr className="artwork-details-horizontal-rule" style={{ display: (this.state.artworkData.artwork.self_created || !!this.state.artworkData.artwork.created_by) ? "" : "none" }}></hr>
                                            <div className="product-details-artwork-dimensions-year-technique" style={{ display: (this.state.artworkData.artwork.self_created || !!this.state.artworkData.artwork.created_by) ? "" : "none" }}>
                                                <p className="product-details-artwork-title">CREATED BY</p>
                                                <p className="product-details-artwork-value">{(this.state.artworkData.artwork.self_created) ?
                                                    (this.state.artworkData.artwork.user_profile.display_name) ?
                                                        this.state.artworkData.artwork.user_profile.display_name :
                                                        this.state.artworkData.artwork.user_profile.old_display_name :
                                                    (!!this.state.artworkData.artwork.created_by) ? this.state.artworkData.artwork.created_by : ""}</p>
                                            </div>
                                            <hr className="artwork-details-horizontal-rule"></hr>
                                            <div className="product-details-artwork-dimensions-year-technique">
                                                <p className="product-details-artwork-title">YEAR</p>
                                                <p className="product-details-artwork-value">{(this.state.artworkData.artwork.year) ? this.state.artworkData.artwork.year : this.state.artworkData.artwork.old_year}</p>
                                            </div>
                                            <hr className="artwork-details-horizontal-rule"></hr>
                                            <div className="product-details-artwork-dimensions-year-technique">
                                                <p className="product-details-artwork-title">UPLOADED ON</p>
                                                <p className="product-details-artwork-value">{this.state.uploaded_on}</p>
                                            </div>

                                        </div>
                                        <div className="product-details-artist-profile">
                                            <div className="same-row">
                                                <div className="product-details-artist-profile-picture" style={{ cursor: "pointer" }}>
                                                    <img className="profile-picture-artist-details" onClick={() => this.handleViewProfileClick(this.state.artworkData.artwork.user_profile.id)} src={this.state.artworkData.artwork.user_profile.image || require('../../assets/default_picture.png')} />
                                                </div>
                                                <div className="artist-profile-name-and-location">
                                                    <p className="artist-name">{(this.state.artworkData.artwork.user_profile.display_name) ? this.state.artworkData.artwork.user_profile.display_name : this.state.artworkData.artwork.user_profile.old_display_name}</p>
                                                    <hr className="artist-profile-horizontal-rule"></hr>
                                                    <p className="artist-location">{this.state.artworkData.artwork.user_profile.country}</p>
                                                </div>
                                            </div>
                                            <Button onClick={() => this.handleViewProfileClick(this.state.artworkData.artwork.user_profile.id)} id="view-profile-btn" className="masterpieces-secondary-buttons">VIEW PROFILE</Button>
                                        </div>
                                        <div className="product-details-artwork-story">
                                            <div className="artwork-story-title">The Story</div>
                                            <p className="artwork-story-content">{this.state.artworkData.artwork.description}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="rectangle-featured-artworks" ref={this.artworksRef} >
                                <div className="title-featured-artworks" >
                                    RELATED ARTWORKS
                                    <hr className="line-category-name "></hr>
                                </div>
                                <div className="row mt-15 mb-15 pb-15" style={{ overflowX: "hidden", flexWrap: "nowrap" }}>
                                    <div className="scroll-x-block">
                                        <Artwork artworkData={this.state.featuredArtworksList} />

                                    </div>
                                </div>
                            </div> */}
                        </div >

                    </Modal.Content>
                </Modal>
                : <div></div>
        )
    }
}



const BuyRequestButton = (props) => {
    let { handleBuyRequestBtn, buyRequestDone, myOwnArtwork } = props;
    return ((!myOwnArtwork) ?
        <Button onClick={handleBuyRequestBtn} style={{ flex: 1 }}
            className={(buyRequestDone) ? "masterpieces-secondary-buttons request-btn plr-15" : "masterpieces-primary-buttons request-btn plr-15"}>
            <p style={{ color: (buyRequestDone) ? '#333333' : '#FFFFFF' }}> {(buyRequestDone) ? 'BUY REQUEST SENT' : 'PLACE BUY REQUEST'}</p>
        </Button>

        :
        <Button onClick={handleBuyRequestBtn} style={{ flex: 1 }}
            className="masterpieces-tertiary-black-button request-btn">
            <p>EDIT ARTWORK INFO</p>
        </Button>
    )
}


const ImagePreviewWindow = (props) => {
    let { imageList, handleImageCarouselClick } = props;

    return (
        (imageList && imageList.length) ? (
            imageList.map(
                (el, elIndex) => (
                    < img key={elIndex} onClick={((el.url) ? () => handleImageCarouselClick(el.url) : "")} className="product-details-list-image" src={el.url || require('../../assets/artwork_image.png')} />
                )
            )
        )
            : <div></div>
    )
}


// WEBPACK FOOTER //
// ./src/components/products/artworkDetailsModal.js